import React, { useState } from 'react';
import { Form, Input, Button, message } from 'antd';
import './Studentlogin.css'; 

const StudentLogins = () => {
    const [loading, setLoading] = useState(false);

    const onFinish = (values) => {
        setLoading(true);
        // Simulate login API call
        setTimeout(() => {
            setLoading(false);
            // Corrected the logic for valid login credentials
            if (
                (values.email === 'info@chosenacademy.co.in' && values.password === 'password123') ||
                (values.email === 'info@chosenacademy.co.in' && values.password === 'password124') ||
                (values.email === 'info@chosenacademy.co.in' && values.password === 'password125')
            ) {
                message.success('Login successful!');
                // Redirect to student dashboard or other actions
            } else {
                message.error('Invalid email or password. Please try again.');
            }
        }, 1000);
    };

    const onFinishFailed = (errorInfo) => {
        message.error('Please check the input fields and try again.');
    };

    return (
        <div className="student-login-container">
            <div className="login-box">
                <h1>Student Login</h1>
                <Form
                    name="login"
                    layout="vertical"
                    initialValues={{ remember: true }}
                    onFinish={onFinish}
                    onFinishFailed={onFinishFailed}
                    className="student-login-form"
                >
                    <Form.Item
                        label="Email"
                        name="email"
                        rules={[
                            { required: true, message: 'Please enter your email!' },
                            { type: 'email', message: 'Please enter a valid email address!' },
                        ]}
                    >
                        <Input placeholder="Enter your email" />
                    </Form.Item>

                    <Form.Item
                        label="Password"
                        name="password"
                        rules={[{ required: true, message: 'Please enter your password!' }]}
                    >
                        <Input.Password placeholder="Enter your password" />
                    </Form.Item>

                    <Form.Item>
                        <Button type="primary" htmlType="submit" block loading={loading}>
                            Login
                        </Button>
                    </Form.Item>
                </Form>
            </div>
        </div>
    );
};

export default StudentLogins;
